export enum INTERCOM_EVENTS {
  boot = 'boot',
  shutdown = 'shutdown',
  show = 'show',
}
